<template>
  <div class="client__profile" v-if="client">
    <div class="card">
      <BRow>
        <ClientId :client="client"></ClientId>
        <BCol>
          <BRow class="no-gutters px-4 px-md-0 mt-md-5">
            <BCol class="p-md-2 client__profile__content">
              <div v-html="narrative"></div>
            </BCol>
          </BRow>
          <BRow class="no-gutters px-4 pl-md-0 pr-md-2 mt-4">
            <BCol class="py-3 pl-2 text-white client__profile__title">
              {{ $t('clientProfile.revelations') }}
            </BCol>
          </BRow>
          <BRow class="no-gutters px-4 pl-md-0 pr-md-2">
            <BCol class="py-1 pl-2 client__profile__text" cols="12" md="">
              <div class="font-weight-bolder">
                {{ client.by_the_numbers___time_period }}
              </div>
              <div class="client__profile__title__small font-weight-light">
                {{ $t('clientProfile.years') }}
              </div>
            </BCol>
            <BCol class="py-1 pl-2 client__profile__text" cols="12" md="">
              <div class="font-weight-bolder">
                {{ client.by_the_numbers___banks_used }}
              </div>
              <div class="client__profile__title__small font-weight-light">
                {{ $tc('clientProfile.banks', client.by_the_numbers___banks_used) }}
              </div>
            </BCol>
            <BCol class="py-1 pl-2 client__profile__text" cols="12" md="">
              <div class="font-weight-bolder">
                {{ client.by_the_numbers___sars }}
              </div>
              <div class="client__profile__title__small font-weight-light">
                {{ $tc('clientProfile.sars', client.by_the_numbers___sars) }}
              </div>
            </BCol>
            <BCol class="py-1 pl-2 client__profile__text"  cols="12" md="">
              <div class="font-weight-bolder">
                {{ client.by_the_numbers___transactions }}
              </div>
              <div class="client__profile__title__small font-weight-light">
                {{ $tc('clientProfile.transactions', client.by_the_numbers___transactions) }}
              </div>
            </BCol>
            <BCol class="py-1 pl-2 client__profile__text" cols="12" md="">
              <div class="font-weight-bolder">
                {{ client.by_the_numbers___money_flows___short_version }}
              </div>
              <div class="client__profile__title__small font-weight-light">
                {{ $t('clientProfile.total') }}
              </div>
            </BCol>
          </BRow>
          <BRow class="no-gutters px-4 px-md-0 mt-3">
            <BCol class="p-md-2 pb-4 client__profile__content">
              <div class="mb-2" v-html="revelations"></div>
            </BCol>
          </BRow>
        </BCol>
      </BRow>
    </div>
  </div>
</template>

<script>
  import replace from 'lodash/replace'
  import snarkdown from 'snarkdown'

  import ClientId from '@/components/ClientId'

  export default {
    name: 'ClientProfile',
    components: {
      ClientId
    },
    props: {
      client: {
        type: Object
      }
    },
    computed: {
      narrative () {
        return snarkdown(replace(this.client.narrative, /\r/g, ''))
      },
      revelations () {
        const html = snarkdown(replace(this.client.what_the_files_reveal, /\r/g, ''))
        return replace(html, /strong>/g, 'mark>')
      }
    },
    beforeRouteEnter (to, from, next) {
      next(_ => {
        document.getElementById('app__container').scrollTop = 0
      })
    },
    beforeRouteUpdate (to, from, next) {
      document.getElementById('app__container').scrollTop = 0
      next()
    }
  }
</script>

<style lang="scss" scoped>
  .client__profile {
    letter-spacing: 1px;
    padding: 19px 0;

    &__title {
      background-color: #808080;
      border: 1px solid #808080;
      font-weight: 900;
    }

    &__text {
      border: 1px solid black;
      border-bottom-width: 0;

      &:last-child {
        border-bottom-width: 1px;
      }

      &__small {
        font-size: small;
      }
    }

    &__content {
      line-height: 25px;

      /deep/ mark {
        background-color: var(--app-yellow);
      }
    }
  }

  @media (min-width: 768px) {
    .client__profile {

      &__text {
        border-right: none;
        border-bottom-width: 1px;

        &:last-child {
          border-right: 1px solid black;
        }
      }
    }
  }
</style>
